// Centers the floating carousel arrows on the product image instead of the whole
// product card, which also contains the title/price block underneath the image.
// The image ratio is a theme setting (and can be "natural"), so the figure height
// is measured rather than derived.

const CONTAINER_SELECTOR = '.floating-controls-container';
const FIGURE_SELECTOR = '.product-card__figure';

if (window.ResizeObserver) {
  const tracked = new WeakSet();

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const container = entry.target.closest(CONTAINER_SELECTOR);
      if (!container) return;

      const height = entry.borderBoxSize?.length ? entry.borderBoxSize[0].blockSize : entry.target.clientHeight;
      if (height > 0) {
        container.style.setProperty('--floating-controls-center-block', `${Math.round(height / 2)}px`);
      }
    });
  });

  const align = () => {
    document.querySelectorAll(CONTAINER_SELECTOR).forEach((container) => {
      const figure = container.querySelector(FIGURE_SELECTOR);
      if (!figure || tracked.has(figure)) return;

      tracked.add(figure);
      resizeObserver.observe(figure);
    });
  };

  let frame = null;
  const scheduleAlign = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      align();
    });
  };

  align();

  // Carousels can arrive after load (product recommendations, section reloads).
  new MutationObserver(scheduleAlign).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleAlign);
}
